export default "__VITE_ASSET__p69Bzlkv__"